import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { signUp } from '../../../../actions/user';
import { msg } from '../../../../actions/swal_msg';
import TurnstileWidget from '../../../Security/TurnstileWidget';
import {
    consumeCaptchaToken, isCaptchaError, normalizeEmail,
    requireCaptchaAfterAttempt, validateNewPassword
} from '../../../../helpers/security';

//CSS
import '../SignUp.css';

//IMG
// import logo_mobile from '../../../../assets/images/Logo.png'
// import logo_desktop from '../../../../assets/images/Logo_Nefropolis.png'

import { regex_email } from '../../../../constants/regex';

//MUI
import {
    FormControl, TextField, InputLabel, OutlinedInput, InputAdornment,
    IconButton, Container, Box, Typography, Button, Grid, Link, useMediaQuery
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';

const benefits = [
    {
        icon: <LockIcon />,
        iconColor: '#45b39d',
        title: 'Seguridad mejorada',
        text: 'Protección y seguridad para tus datos y transacciones.',
    },
    {
        icon: <ShoppingCartCheckoutIcon />,
        iconColor: '#e67e22',
        title: 'Experiencia personalizada',
        text: 'Revisa tu historial de compras y obten recomendaciones personalizadas.',
    },
    {
        icon: <AddLocationAltIcon />,
        iconColor: '#e74c3c',
        title: 'Facilidad en el proceso de compra',
        text: 'Guarda tu información de envío para compras más rápidas.',
    },
    {
        icon: <NotificationsActiveIcon />,
        iconColor: '#a569bd',
        title: 'Notificaciones y actualizaciones',
        text: 'Recibe alertas sobre nuevos productos, restock de artículos, ventas flash, etc.',
    },
    {
        icon: <LocalShippingIcon />,
        iconColor: '#5499c7',
        title: 'Seguimiento de pedidos',
        text: 'Monitoreo del estado de tus pedidos en tiempo real.',
    },
];

const Registro = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [values, setValues] = useState({
        username: '', fullname: '',
        email: '', password: ''
    });
    const { username, email, password } = values;
    const [togglePasword, setTogglepassword] = useState(false);
    const [security, setSecurity] = useState({ required: false, token: '', key: 0 });

    const matches = useMediaQuery('(max-width: 991.5px)');
    const matches_p = useMediaQuery('(max-width: 950px)');
    
    // cambios formulario
    const handleChange = ({ target: { name, value } }) => {
        if (name === 'email')
            setValues({ ...values, [name]: value.toLowerCase() });
        else
            setValues({ ...values, [name]: value });
    };

    // registro usuario
    const submit = async () => {
        if (formValidator()) {
            const token = security.token;
            if (token) setSecurity(current => consumeCaptchaToken(current, token));
            const body = await dispatch(signUp({
                ...values, email: normalizeEmail(email),
                turnstile_token: token,
                origin: 'website',
                page: props.page
            }));
            if (isCaptchaError(body)) setSecurity(current =>
                requireCaptchaAfterAttempt(current, token));
        }
    };

    // validación formulario
    const formValidator = () => {
        const user_len = username.trim().length;
        const email_len = email.trim().length;
        const passwordError = validateNewPassword(password, values);
        if (user_len > 4 && user_len <= 100) {
            if (email_len > 5 && email_len <= 120
                && regex_email.test(email)) {
                if (!passwordError)
                    return true;
                else
                    msg('warning', 'Registro',
                        passwordError);
            } else
                msg('warning', 'Registro',
                    'Ingrese su correo electrónico');
        } else
            msg('warning', 'Registro',
                'Ingrese un nombre de usuario');
        return false;
    };

    const togglePassword = () => {
        setTogglepassword(!togglePasword);
    };

    return (
        <div className='bg_signup'>
            <Container maxWidth='xxl' sx={{ py: matches_p ? 5 : 10 }} className='signup_container'>
                <Grid container spacing={6}>
                    <Grid item xl={7} lg={6.5} md={12} sm={12} xs={12} order={{ xl: 1, lg: 1, md: 2, sm: 2, xs: 2 }}>

                        <Typography variant='h5' color='text.secondary' className='benef_text' sx={{ fontWeight: 'bold', fontSize: '30px' }}>
                            Crea tu cuenta en Nefrópolis y disfruta de grandes beneficios:
                        </Typography>

                        <Box sx={{ mt: 5 }}>
                            <Grid container spacing={5}>
                                {
                                    benefits.map((res, index) => (
                                        <Grid item xl={4} lg={5} md={6} sm={6} xs={6} key={index}>
                                            <Box className='circle_icon'>
                                                <Box sx={{ color: res.iconColor }}>
                                                    {res.icon}
                                                </Box>
                                            </Box>

                                            <Box sx={{ mt: 2 }}>
                                                <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                                                    {res.title}
                                                </Typography>
                                                <Typography variant='body1'>
                                                    {res.text}
                                                </Typography>
                                            </Box>

                                        </Grid>
                                    ))
                                }
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xl={5} lg={5.5} md={12} sm={12} xs={12} order={{ xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                        {
                            matches ?
                                <Typography variant='h5' color='text.secondary' sx={{ fontWeight: 'bold', mb: 3 }} textAlign='center'>
                                    Crear una cuenta
                                </Typography>
                                :
                                null
                        }
                        <Box className='form_signup'>
                            {/* Nombre */}
                            <FormControl fullWidth sx={{ mb: 2.5 }}>
                                <TextField id="" label="Nombre y apellido" variant="outlined"
                                    name='username'
                                    value={username}
                                    onChange={handleChange} />
                            </FormControl>

                            {/* Correo electronico */}
                            <FormControl fullWidth sx={{ mb: 2.5 }}>
                                <InputLabel>Correo electrónico</InputLabel>
                                <OutlinedInput
                                    id="pass-input"
                                    type='email'
                                    placeholder=""
                                    label="Correo electrónico"
                                    name='email'
                                    value={email}
                                    onChange={handleChange}
                                    onBlur={() => setValues(current => ({
                                        ...current, email: normalizeEmail(current.email)
                                    }))}
                                />
                            </FormControl>

                            {/* Contraseña con metodo para mostrar y ocultar */}
                            <FormControl fullWidth>
                                <InputLabel>Contraseña</InputLabel>
                                <OutlinedInput
                                    id="pass-input1"
                                    type={togglePasword ? "text" : "password"}
                                    style={{ backgroundColor: '#fff' }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={togglePassword}

                                                edge="end"
                                            >
                                                {togglePasword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Contraseña"
                                    name='password'
                                    value={password}
                                    onChange={handleChange}
                                />
                            </FormControl>

                            {security.required &&
                                <TurnstileWidget key={security.key} action="signup"
                                    onVerify={token => setSecurity(current => ({ ...current, token }))} />}

                            {/* Recordar contraseña */}
                            {/* <Box>
                                <FormControlLabel control={<Checkbox defaultChecked={false} size="small" />} label="Recordar contraseña" />
                            </Box> */}

                            {/* button continuar con registro */}
                            <Box sx={{ mt: 2.5, textAlign: 'center' }}>
                                <Button variant='contained' sx={{ fontWeight: '600', width: '100%', height: '55px' }} onClick={submit}>
                                    <span style={{ fontSize: '13px' }}>Crear cuenta</span>
                                </Button>
                                {/* onClick={props.nextstep} */}
                            </Box>

                            {/* Link iniciar sesión */}
                            <Box sx={{ mt: 3 }}>
                                <Typography variant='body1' color='text.secondary' sx={{ fontStyle: 'italic' }}>
                                    ¿Ya tienes cuenta? <u>
                                        <Link component="button"
                                            style={{ color: '#2699FB' }}
                                            onClick={() => {
                                                navigate("/login", { state: { page: props.page } })
                                            }}>Iniciar sesión
                                        </Link>
                                    </u>
                                </Typography>
                            </Box>

                            {/* Avisos de privacidad */}
                            <Box sx={{ mt: 3 }}>
                                <Typography variant='body1' color='text.secondary' sx={{ fontStyle: 'italic' }}>
                                    Al crear una cuenta aceptas las <u>
                                        <Link component="button"
                                            style={{ color: '#2699FB' }}
                                            onClick={() => {
                                                navigate("/terminos-y-condiciones")
                                            }}>condiciones de uso
                                        </Link>
                                    </u> y el <u>
                                        <Link component="button"
                                            style={{ color: '#2699FB' }}
                                            onClick={() => {
                                                navigate("/politica-de-privacidad")
                                            }}>aviso de privacidad
                                        </Link>
                                    </u> de Nefrópolis
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};

export default Registro;
